<!-- 快捷定位 -->
<template>
  <div class="breadcrumb-wrap">
    <el-breadcrumb class="breadcrumb" separator-class="el-icon-arrow-right">
      <i class="icon el-icon-s-home"></i>
      <el-breadcrumb-item
        :to="item.path"
        v-for="item in breadcrumbs"
        :key="item.name"
        >{{ item.name }}</el-breadcrumb-item
      >
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    breadcrumbs: {
      type: Array,
      default: () => [],
    },
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.breadcrumb-wrap {
  width: 100%;
  height: 50px;
  border-bottom: 1px solid #e1e5e7;
  margin-bottom: 20px;
  display: flex;
  align-items: center;

  .el-breadcrumb {
    width: 1200px;
    margin: 0 auto;

    .icon {
      float: left;
      margin-right: 5px;
      color: $theme;
    }
  }
}
</style>
